import { Insta } from '../../src/components/insta/InstaClass';
import { Phone } from '../../src/components/phoneUI/PhoneClass';
import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import UI from '../../src/shell/UI';
import { jump } from "../../src/shell/jump";
import { alex } from '../characters/Alex';
import { ann } from "../characters/Ann";
import { chris } from '../characters/Chris';
import { emily } from "../characters/Emily";
import { empty } from "../characters/empty";
import { joe } from "../characters/Joe";
import { mc } from "../characters/MC";
import { vanessa } from '../characters/Vanessa';
import { vanessaMom } from '../characters/VanessaMom';
import { annImages } from '../helpers/annInstaImages';
import { doDoorKnock, doDoorRing, doTransition, doWaitImageByTime, isAnnGF } from '../helpers/helpers';
import { getInstaData } from '../helpers/InstaPostsHelpers';
import { vanessaDad } from './../characters/VanessaDad';
import { extras, images, uiImages } from "./images";
import { V5AnnSexEvening2 } from './V5_AnnRoomSex';
import { V5AnnLibrary } from './V5_AnnLibrary';
import { V5AnnMovie } from './V5_AnnMovies';
import { V5EmilyBeach } from './V5_EmilyBeach';
import { JoeyBeach1 } from './V5_JoeyBeach';
import { V5ChrisRandomGirl } from './V5_Merry';
import { V5VanessaHouseMorningVanessasFatherConversation } from './V5_VanessaMorning';
import { V6AlexEasterEgg2, V6Start } from './V6';


export const V5Start = async (): Promise<any> => {


    if (mc.properties.annStatus === "gf") {
        return jump(V5McAnnRoomMorning, "V5McAnnRoomMorning");
    } else {

    }


    return jump(V5McNoAnnRoomMorning, "V5McNoAnnRoomMorning");
};
export const V5McAnnRoomMorning = async (): Promise<any> => {
    if (ann.properties.corruption >= 9 || (Question.globalAnswers.v4AnnCorruptionConvWhatDoYouThink === "youShouldChange" && ann.properties.corruption > 4)) {
        await ann.set((properties) => {
            properties.isCorrupted = true;
        });
    }

    doWaitImageByTime(images.v2_5.BlackScreen, null, 2);
    ann.talk(`${mc.name}?`);
    ImageClass.setImage(images.v5.AnnMorningAfter_26);
    mc.talk(`Ann, you are up.`);
    ImageClass.setImage(images.v5.AnnMorningAfter_27);
    ann.talk(`Hehe, yeah, I always wake up early.`);
    ann.talk(`I didn't want to go before I said goodbye.`);
    if (Question.globalAnswers.afterTODEnteredNaked) {

        ann.talk(`Last time I slept here, I ran out screaming, hehe.`);
        mc.talk(`I'm glad that's not the case anymore.`);
    }

    ann.talk(`And... I wanted to talk to you about something.`);
    ann.talk(`Oh, wait. I'm sorry, you just woke up...it's a bad time.`);
    mc.talk(`I'm already up, what is it?`);
    // TODO: Ann will ask the MC what happened with Vanessa last night (if happened)
    ImageClass.setImage(images.v5.AnnMorningAfter_29);
    ann.talk(`I was just laying in bed with all these thoughts running through my head...`);
    if (mc.properties.annBarCorruptionConv) {

        ann.talk(`I kept thinking about our conversation yesterday...`);
    } else {

        ann.talk(`I was wondering if you are happy with our relationship.`);
    }
    if (Question.globalAnswers.v4AnnCorruptionConvWhatDoYouThink === "youShouldChange") {
        ann.talk(`We both agreed that I should change, and I think the first step is...`);
        ann.talk(`...to be more sexually open.`);
    } else if (Question.globalAnswers.v4AnnCorruptionConvWhatDoYouThink === "StayLikeYouAre") {
        ann.talk(`We both agreed that I should stay as I am, but I still want to be more...`);
        ann.talk(`...sexually open...`);

    }

    ImageClass.setImage(images.v5.AnnMorningAfter_30);
    ann.talk(`I mean yesterday there were a lot of girls at the bar; you could have picked anyone and probably had sex with them...`);

    ImageClass.setImage(images.v5.AnnMorningAfter_31);
    if (mc.properties.annLateGF) {
        ann.talk(`But you chose to go home with me...`);
        ann.talk(`And it's really boosting my confidence.`);
        if (Question.globalAnswers.v4AnnCorruptionConvWhatDoYouThink === "youShouldChange") {
            ann.talk(`And it makes me believe I'm doing the right thing embracing these new feelings.`);
        } else {
            ann.talk(`I just met you a couple of days ago and have already done more with you than I've ever done in my life...`);
            mc.think(`That I can believe.`);
        }


    } else {
        ann.talk(`But you chose to stay with me.`);
        mc.talk(`You know I like you.`);

        // ann.talk(`Yes, I do, but sometimes I think I'm pushing it.`);
    }

    ImageClass.setImage(images.v5.AnnMorningAfter_30);

    if (mc.properties.annLateGF) {
        if (Question.globalAnswers.v4AnnCorruptionConvWhatDoYouThink === "youShouldChange") {
            ann.talk(`But I also feel like I'm punishing you for that.`);
            if (mc.properties.alpha >= 5) {
                mc.talk(`Can't disagree with you there.`);
            } else {
                mc.talk(`It's not like that at all.`);
                mc.talk(`It is my choice. `);

            }
            mc.talk(`And it's not like we didn't do anything.`);
            ann.talk(`Yes... But not... Sex.`);


        } else {
            ann.talk(`I want you to know that I'm not like those girls that you can take on a one night stand.`);
            mc.talk(`I know you are not.`);
            ann.talk(`Yes... But that's what happened, right?`);
            mc.talk(`It's different. I like you. We clicked and we did what we did.`);
            ann.talk(`I agree about the click. Hehe.`);
        }

    } else {
        ann.talk(`I am having fun when we are together... you know... in bed. But once we are done, and I'm going to sleep, I feel strange.`);
        ann.talk(`Maybe it's just me being paranoid... I don't know.`);
        mc.talk(`How do you feel?`);
    }
    ImageClass.setImage(images.v5.AnnMorningAfter_30);

    if (mc.properties.annLateGF) {
        ann.talk(`You know... I lack experience... Like a lot.`);
        ann.talk(`I bet you noticed that yesterday...`);
    } else {
        ann.talk(`Like a feeling of unfulfilled desires...\nI don't know how to explain it...`);
        mc.talk(`That doesn't sound very positive.`);
        ann.talk(`It depends on how you look at it.`);
    }

    ImageClass.setImage(images.v5.AnnMorningAfter_31);
    if (mc.properties.annLateGF) {
        ann.talk(`So basically, what I want to say is...`);
        ann.talk(`That I might need help...`);
        mc.talk(`What kind of help?`);
        ann.talk(`You know... Some guidance with all this... But a female guidance.`);
    } else {
        ann.talk(`I want to be more intimate with you, more than now.`);
        mc.talk(`Why is that a problem?`);
        ann.talk(`Because I feel I'm at that point where I've waited too long and now it's becoming harder and harder to commit.`);
    }

    if (mc.properties.annBarCorruptionConv) {
        mc.talk(`Why didn't you mention it yesterday?`);
        ann.talk(`I don't know... I guess I wanted to take it one step at a time.`);
        ann.talk(`And mainly because it just popped in my head while I was laying here in bed... Next to you.`);
    } else {
        mc.talk(`Well I'm sure we can figure out something for you.`);
    }
    ann.talk(`I even had a funny thought about asking Vanessa for help.`);
    ann.talk(`But I don't know... She will just make fun of me.`);
    ImageClass.setImage(images.v5.AnnMorningAfter_31);

    return jump(V5McAnnRoomMorning2, "V5McAnnRoomMorning2");

};

export const V5McAnnRoomMorning2 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnMorningAfter_30, { transition: true });
    ann.talk(`When I say it out loud, I realize how stupid that idea is...`);
    mc.talk(`Stupid? It's actually sounds like a great idea.`);
    ImageClass.setImage(images.v5.AnnMorningAfter_30);
    ann.talk(`You are just saying that because you want to see her make fun of me.`);
    mc.talk(`Not true, I honestly think she can help.`);
    mc.talk(`You know she wants the best for you.`);
    mc.think(`Most of the time...`);
    ImageClass.setImage(images.v5.AnnMorningAfter_28);
    ann.talk(`That's true! She introduced me to you! Hehe.`);

    mc.talk(`I can talk to her for you if you want.`);
    ImageClass.setImage(images.v5.AnnMorningAfter_33);
    ann.talk(`What? No! That will give her another reason to make fun of me.`);
    ImageClass.setImage(images.v5.AnnMorningAfter_30);
    ann.talk(`What would you say anyway?`);
    ann.talk(`"Hey Vanessa, Ann needs your help, she doesn't know how to have sex with me?"`);
    mc.talk(`Yes.`);
    ann.talk(`...`);
    mc.talk(`I'm joking, I won't say you need help. I'll make it about me.`);
    mc.talk(`I'll say that we need to use her experience.`);
    ann.talk(`You know it's a TERRIBLE idea, right?`);
    mc.talk(`Yes.`);
    ann.talk(`Uff... Fine.`);
    ann.talk(`But remember that it was your idea!`);
    mc.talk(`Everything will be fine, you'll see.`);
    ann.talk(`I hope so...`);
    ImageClass.setImage(images.v5.AnnMorningAfter_28);
    ann.talk(`Well, even though this talk didn't go like I imagined it, it really helped me, so thank you.`);
    ann.talk(`It's good to get things off my chest.`);
    if (mc.properties.alpha >= 5) {
        if (ann.properties.isCorrupted) {
            mc.talk(`I was hoping to get this bra off your chest.`);

        } else {

            mc.talk(`I was hoping to get this dress off your chest.`);
        }

        ImageClass.setImage(images.v5.AnnMorningAfter_30);

        ann.talk(`...`);
        mc.talk(`It's a joke.`);
    } else {
        mc.talk(`That's true, talking to someone always helps.`);
        ann.talk(`Yes, thanks for that.`);
    }

    ImageClass.setImage(images.v5.AnnMorningAfter_28);


    if (ann.properties.isCorrupted) {

        ann.talk(`Hehe.`);
        ann.talk(`Anyway, I'll get dressed and get going.`);
    } else {

        ann.talk(`Anyway, I'll get going now.`);
    }

    ann.talk(`It was fun, thanks again ${mc.name}.`);
    ImageClass.setImage(images.v5.AnnMorningAfter_32);
    ann.talk(`MUAH!`);


    ImageClass.setImage(images.v5.AnnMorningAfter_Bra_34, { transition: true, duration: 1 });

    ann.talk(`Bye bye!`);
    mc.talk(`Bye Ann.`);


    return jump(V5McRoomMorningAnnLeft, "V5McRoomMorningAnnLeft");
};

export const V5McRoomMorningAnnLeft = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnMorningAfter_35, { duration: 1 });
    if (mc.properties.joeStatus === "enemy") {
        return jump(V5VanessaHouseMorningJoeStatus6, "V5VanessaHouseMorningJoeStatus6");

    } else {

    }
    return jump(V5VanessaHouseMorningJoeStatusNot6, "V5VanessaHouseMorningJoeStatusNot6");

};


export const V5McNoAnnRoomMorning = async (): Promise<any> => {
    if (Game.seenScenarios.includes(`V5McNoAnnRoomMorning`)) {
        ImageClass.setImage(images.v1.Room2);
    } else {
        ImageClass.setImage(images.v2_5.BlackScreen, { duration: 2, wait: 2.5 });
        ImageClass.setImage(images.v1.Room2);
        mc.think(`Morning.`);
    }


    if (mc.properties.joeStatus === "enemy") {
        return jump(V5VanessaHouseMorningJoeStatus6, "V5VanessaHouseMorningJoeStatus6");

    } else {
        mc.think(`Yesterday was something...`);
        mc.think(`I know that Ann and I aren't on best terms, but I gotta check if she got home safe.`);
        await Phone.showMessagesUI({ name: ann.name, profileImage: annImages.Ann5 }, async () => {
            Phone.setMessage({ character: mc.character, text: `Ann?`, options: { wait: false } });
            Phone.setMessage({ character: mc.character, text: `?`, options: { wait: true } });
            Phone.talk({ character: mc.character, text: `No answer...` });
            Phone.closeMessagesUI();
        });
        mc.think(`Maybe Vanessa knows if she is ok.`);
        ImageClass.setImage(images.v1.JoeyCallBed1);
        mc.think(`...`);
        mc.think(`No answer...`);

        mc.think(`I don't know where Ann lives, so I'll just ask Vanessa if she heard from her.`);
    }
    return jump(V5VanessaHouseMorningVanessasFatherConversation, "V5VanessaHouseMorningVanessasFatherConversation");
};

export const V5VanessaHouseMorningJoeStatus6 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnMorningAfter_36);
    mc.think(`Vanessa's phone...`);
    ImageClass.setImage(images.v5.AnnMorningAfter_36_2);
    mc.think(`I completely forgot about that.`);
    mc.think(`I should return it... I hope she's awake.`);
    if (mc.properties.annLateGF) {

        mc.think(`It's also a good excuse to show up at her place.`);
    } else {

    }
    if (Game.seenScenarios.includes(`AfterClubVanessaLeftAlone2`)) {

        mc.think(`She was wasted when I took her home.`);
    } else {
        mc.think(`She was wasted while she was talking to Joey on the bench.`);
    }

    return jump(V5VanessaHouseMorningVanessasFatherConversation, "V5VanessaHouseMorningVanessasFatherConversation");




};

export const V5VanessaHouseMorningJoeStatusNot6 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnMorningAfter_35);

    if (mc.properties.annStatus === "gf") {
        if (Question.globalAnswers.v4SexTapeFuckedVanessa) {

            mc.think(`I hope Ann doesn't find out about last night... `);
            mc.think(`I did cheat on her with Vanessa...`);
        } else {

        }
        if (ann.properties.isCorrupted && mc.properties.annBarCorruptionConv) {

            mc.think(`She wasn't kidding back at the bar... She really wants to make a significant change in her life...`);
            // mc.think(`I'm not going to complain about that, but I think I might've triggered it.`);
        } else {

            mc.think(`I have no idea what I did that made her want to speed things up, but I'm not complaining.`);
        }
        mc.think(`I've been dying to fuck her so glad that happened sooner rather than later.`);
        mc.think(`I should go over to Vanessa's house now before Ann changes her mind.`);

    }

    return jump(V5VanessaHouseMorningVanessasFatherConversation, "V5VanessaHouseMorningVanessasFatherConversation");
};



export const V5HomeAfterVanessaHome = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomComputerAlone);
    if (!Game.seenScenarios.includes(`V5HomeAfterVanessaHome`)) {
        await alex.set((properties) => {
            properties.instaFollowing = 70;
            properties.instaFollowers = 123888;
        });
    }
    await UI.add({
        key: "V5HomeAfterVanessaButtons",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.continue, tooltip: "Play video games", key: "continue" }
            ]
    });
    if (UI._globalUI.V5HomeAfterVanessaButtons === "insta") {
        await Insta.open(getInstaData());
    }
    if (UI._globalUI.V5HomeAfterVanessaButtons === "continue") {
        return jump(V5EmilyMeet, "V5EmilyMeet");

    }
    return jump(V5HomeAfterVanessaHome, "V5HomeAfterVanessaHome");
};


export const V5EmilyMeet = async (): Promise<any> => {
    doDoorRing();
    mc.talk(`The door again...`);
    ImageClass.setImage(images.v5.Arrival_12);
    mc.think(`I barely had time to play... Who is it now?`);
    ImageClass.setImage(images.v5.Arrival_0, { duration: 0.6 });
    emily.talk(`SURPRISE!`);
    mc.talk(`Emily??`);
    mc.think(`What is she doing here? I haven't seen her since she left home a couple of years ago.`);
    const emilysName: string = await Game.showInput({ text: "What is she to you? (She is my:___)", placeholder: emily.properties.relation, key: "enterName2" });
    if (emilysName) {
        await emily.set((properties) => {
            const lower = emilysName.toLocaleLowerCase();
            properties.relation = lower;
        });
    }
    ImageClass.setImage(images.v5.Arrival_13);
    emily.talk(`Why are you just standing there? Doesn't your ${emily.properties.relation} deserve a hug?`);
    ImageClass.setImage(images.v5.Arrival_14);
    emily.talk(`I really missed you.`);
    ImageClass.setImage(images.v5.Arrival_1);
    mc.talk(`What are you doing here?`);
    emily.talk(`You know, it's my home too.`);
    mc.talk(`I know, but after you had left I thought you would never come back.`);
    await emily.setQuestion(new Question({ text: `Things changed.`, options: { think: false }, key: `v5ComplimentedEmilyWhenArrived` })
        .option({ title: `Compliment her`, key: true })
        .option({ title: `Don't compliment`, key: false }));


    if (Question.globalAnswers.v5ComplimentedEmilyWhenArrived) {
        await mc.set((properties) => {
            properties.emilyRelationship++;
        });
        mc.talk(`You look great!`);
        emily.talk(`Awww... Thank you, you too!`);
        return jump(V5EmilyMeet_2, "V5EmilyMeet_2");
    } else {

        return jump(V5EmilyMeet_2, "V5EmilyMeet_2");
    }


};
export const V5EmilyMeet_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.Arrival_1);

    mc.talk(`Let's get inside.`);
    ImageClass.setImage(images.v5.Arrival_2);
    emily.talk(`Hold on, I'm waiting for my second bag.`);
    ImageClass.setImage(images.v5.Arrival_3);
    emily.talk(`Thank you Joey!`);
    if (mc.properties.joeStatus === "enemy") {
        joe.talk(`No problem.`);
        ImageClass.setImage(images.v5.Arrival_5);
        joe.talk(`Tell me where to put it and I'll be on my way.`);
        emily.talk(`Don't be ridiculous! Come inside.`);
        joe.talk(`I'm in a hurry.`);
        emily.talk(`Where are you so eager to get to?`);
        joe.talk(`To the beach.`);
        emily.talk(`I've missed the beach!\nWe'll join you.`);
        joe.talk(`I'm sorry but I'd rather go by myself.`);
        emily.talk(`Ok... Well have fun.`);
        ImageClass.setImage(images.v5.Arrival_15);
        emily.talk(`Well, that's his loss!`);
        emily.talk(`Let's just go the two of us.`);
        emily.talk(`I've really missed the beach and it will be a good time for us to catch up.`);
        mc.talk(`Sure why not.`);
        emily.talk(`Amazing!`);
        emily.talk(`I'm gonna get ready and we'll leave.`);

        return jump(V5EmilyBeach, "V5EmilyBeach");
    } else {

    }


    ImageClass.setImage(images.v5.Arrival_4);
    joe.talk(`Great, now I have two people calling me Joey in this town.`);
    emily.talk(`That's your name, you will always be Joey to me.`);
    joe.talk(`I've heard that before...`);
    ImageClass.setImage(images.v5.Arrival_3);
    joe.talk(`Where do you want this bag?`);
    emily.talk(`In the living room please.`);
    ImageClass.setImage(images.v5.Arrival_7, { transition: true });
    emily.talk(`I still can't believe how much you've changed!`);
    ImageClass.setImage(images.v5.Arrival_8);
    emily.talk(`Can you believe it's Joey?`);
    emily.talk(`I wouldn't have recognized him if he didn't tell me it's him.`);
    mc.talk(`Yeah... I'm getting used to the new look myself.`);
    emily.talk(`I'm glad to see you two are still best friends.`);
    ImageClass.setImage(images.v5.Arrival_7);
    joe.talk(`Of course! Why wouldn't we be?`);
    emily.talk(`So if I got this right you barely touch your computer now?`);

    emily.talk(`That's so weird! I remember both of you playing for days without sleep.`);
    joe.talk(`You'd be surprised but ${mc.name} is trying to do the same.`);
    ImageClass.setImage(images.v5.Arrival_8);
    emily.talk(`${mc.name}?? Is that true?`);
    mc.talk(`Guilty.`);
    ImageClass.setImage(images.v5.Arrival_7);
    emily.talk(`I would be glad to stay here and chat, but I had a long drive. I really need some sleep.`);
    joe.talk(`Oh right! Of course. Nice to see you again.`);
    ImageClass.setImage(images.v5.Arrival_8);
    emily.talk(`We will talk later ${mc.name}.`);
    ImageClass.setImage(images.v5.Arrival_9);
    emily.talk(`Have fun, don't cause too much trouble.`);

    return jump(V5AfterEmilyJoeConversation, "V5AfterEmilyJoeConversation");
};

export const V5AfterEmilyJoeConversation = async (): Promise<any> => {
    if (Question.globalAnswers.v4SexTapeAgreeToFilm) {
        ImageClass.setImage(images.v5.Arrival_10);
        joe.talk(`Yesterday was crazy, wasn't it?`);
        mc.talk(`Absolutely! When I suggested to Vanessa that you should make a sex tape I didn't think I would be the one filming it.`);
        mc.talk(`Have you seen it?`);
        joe.talk(`Not yet, Vanessa and I said we will watch it together soon.`);
        if (Game.seenScenarios.includes(`AfterClubSexTapeAgree4JoePassedout`) && Question.globalAnswers.v4TrickJoeyDrinkDrug) {
            joe.talk(`Anyway, I was way too drunk to watch it yesterday.`);
            joe.talk(`I can't believe I passed out.`);
            mc.talk(`It was unexpected.`);
            mc.think(`I don't think he suspects me.`);
            joe.talk(`Nothing bad happened, so I guess we are all good.`);
        }

        joe.talk(`What about you?`);
        mc.talk(`What about me?`);
        joe.talk(`Have you thought about doing something like that with Ann?`);
        mc.talk(`Even if I did, she would never agree to that.`);

        return jump(V5AfterEmilyJoeConversationFriendContinue, "V5AfterEmilyJoeConversationFriendContinue");

    } else {

    }


    ImageClass.setImage(images.v5.Arrival_10);
    joe.talk(`I can't believe that Emily is back!`);
    return jump(V5AfterEmilyJoeConversationFriendContinue_2, "V5AfterEmilyJoeConversationFriendContinue_2");
};

export const V5AfterEmilyJoeConversationFriendContinue = async (): Promise<any> => {
    ImageClass.setImage(images.v5.Arrival_10);
    await joe.setQuestion(new Question({ text: `I didn't ask if she would want to, I asked if you want to.`, options: { think: false }, key: `v5ToldJoeYouWantSexTapeAsWell` })
        .option({ title: `I want.`, key: true })
        .option({ title: `I don't want.`, key: false }));


    if (Question.globalAnswers.v5ToldJoeYouWantSexTapeAsWell) {
        mc.talk(`I want to.`);
        joe.talk(`That's what I love to hear!`);
        joe.talk(`Like I said yesterday, if you need someone to film it, I'm your man!`);
        mc.talk(`Haha, you are being optimistic, she doesn't even feel comfortable with me yet, let alone if someone else would be there.`);
        joe.talk(`Maybe, but we don't really know what hides deep inside her mind.`);

    } else {
        mc.talk(`I don't want to.`);
        joe.talk(`Damn.`);
        joe.talk(`Why not?`);
        mc.talk(`I just don't.`);
        joe.talk(`Well, that's fine. It's not for everyone I guess.`);
    }
    joe.talk(`By the way, I can't believe that Emily is back!`);

    return jump(V5AfterEmilyJoeConversationFriendContinue_2, "V5AfterEmilyJoeConversationFriendContinue_2");
};

export const V5AfterEmilyJoeConversationFriendContinue_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.Arrival_10);
    await joe.setQuestion(new Question({ text: `I must say she is looking better than ever.`, options: { think: false }, key: `v5AgreeWithJoeThatEmilyIsLookingGood` })
        .option({ title: `Agree`, key: true })
        .option({ title: `Disagree`, key: false }));


    if (Question.globalAnswers.v5AgreeWithJoeThatEmilyIsLookingGood) {
        mc.talk(`Yes, the last few years have been good to her.`);
        await mc.set((properties) => {
            properties.emilyRelationship++;
        });
    } else {
        await mc.set((properties) => {
            properties.emilyRelationship--;
        });
        mc.talk(`I don't see it.`);
        mc.talk(`Besides, she is my ${emily.properties.relation}!`);
    }


    joe.talk(`Haha, ${emily.properties.relation} or not, I don't know what I would have done if I had a girl like that living with me in the same house.`);
    mc.talk(`Are you serious?`);
    joe.talk(`Don't tell me you haven't thought about that.`);
    if (Question.globalAnswers.v5AgreeWithJoeThatEmilyIsLookingGood) {

        mc.talk(`No comment.`);
        joe.talk(`I rest my case.`);
    } else {

        mc.talk(`No way!`);
        joe.talk(`Sure, whatever! I'll let you have this one for now.`);
    }
    joe.talk(`You know what?\nWhy are we wasting our time here?`);
    joe.talk(`Before I saw Emily, I was just on my way to the beach.\nWhy don't you join me?`);
    mc.talk(`That's a great idea.`);
    mc.talk(`But I don't have a swimsuit...`);
    joe.talk(`Just stay in your underwear.`);
    mc.talk(`Mmm...`);
    joe.talk(`Come on, I'll do the same if it makes you feel comfortable.`);
    mc.talk(`Are you serious?`);
    joe.talk(`That's what girls do all the time.`);
    mc.talk(`That's different, but fuck it. Let's go.`);
    joe.talk(`Great! My car is just outside.`);
    return jump(JoeyBeach1, "JoeyBeach1");
};


export const V5AfterBeachJoeyOrEmily = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomComputerAlone, { duration: 0.6 });


    mc.think(`The beach wasn't that bad...`);
    if (mc.properties.joeStatus === "enemy") {
        mc.think(`It was nice spending some time with Emily...`);
        mc.think(`We were inseparable when we were young, but when we got older we spent less time together.`);
        mc.think(`But maybe things will be different now.`);
    } else {

        mc.think(`Spending some time with Joey was nice.`);
        if (mc.properties.annStatus === "hate" && mc.properties.annLateHate === false && Question.globalAnswers.v1AllowChrisGetAnnsNumber && Question.globalAnswers.v25JoeTODAgree) {
            mc.think(`I wonder what he is going to do...`);
            mc.think(`It seems like he wants Ann but he also has Vanessa... I guess time will tell.`);

        }
        if (Question.globalAnswers.v5JoeyBeachMadeJennyAngry) {
            mc.think(`There was this hot chick at the beach... To bad my big mouth made her run away.`);

        } else {
            if (Question.globalAnswers.v5JoeyBeachTookJennysNumber) {
                mc.think(`It was worth going with him just to meet Jenny.`);
                mc.think(`But I do wonder if she'll call.`);
            } else {

                mc.think(`But I wonder if I should have asked for her number...`);
            }

        }


    }
    if (isAnnGF() && ann.properties.isCorrupted) {

        return jump(V5AnnMovie, "V5AnnMovie");
    }


    return jump(V5AfterBeachJoeyOrEmilyAlone, "V5AfterBeachJoeyOrEmilyAlone");

};

export const V5AfterBeachJoeyOrEmilyAlone = async (): Promise<any> => {

    if (Question.globalAnswers.v4AgreedToChrisProposal) {

        return jump(V5ChrisBar, "V5ChrisBar");
    }
    return jump(V5AfterBeachJoeyOrEmilyAloneNoEvents, "V5AfterBeachJoeyOrEmilyAloneNoEvents");

};

export const V5AfterBeachJoeyOrEmilyAloneNoEvents = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomComputerAlone);
    if (!Game.seenScenarios.includes(`V5AfterBeachJoeyOrEmilyAloneNoEvents`)) {
        await alex.set((properties) => {
            properties.instaFollowing = 70;
            properties.instaFollowers = 126888;
        });
    }
    await UI.add({
        key: "v5AfterBeachButtons",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.continue, tooltip: "Continue", key: "continue" }
            ]
    });
    if (UI._globalUI.v5AfterBeachButtons === "insta") {
        await Insta.open(getInstaData());
    }
    if (UI._globalUI.v5AfterBeachButtons === "continue") {
        if (mc.properties.agreeToChrisProposal) {
            return jump(V5ChrisBar, "V5ChrisBar");

        } else {

        }
        ImageClass.setImage(images.v2_5.BlackScreen, { duration: 2, wait: 2.5 });
        ImageClass.setImage(images.v1.RoomComputerAlone);
        mc.think(`It's been a while, and it's already evening.`);
        mc.think(`I hear noises coming from the living room.`);
        return jump(V5EmilyNight, "V5EmilyNight");

    }
    return jump(V5AfterBeachJoeyOrEmilyAloneNoEvents, "V5AfterBeachJoeyOrEmilyAloneNoEvents");

};


export const V5AfterAnnMovie = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomComputerAlone, { transition: true });

    if (Game.seenScenarios.includes(`V5AnnMovieAgree_2_1_Inside_Touch`)) {

        mc.think(`Damn, she turned me on so much today that I actually thought I'm going to fuck her right there in my living room.`);
        mc.think(`I'll have to wait a bit more, but I feel it coming.`);
    }
    if (Game.seenScenarios.includes(`V5AnnMovieEndChris`)) {
        mc.think(`I wonder if Chris is bluffing about the tickets...`);

        if (Question.globalAnswers.v4NoJoeyWasMeanToChris === false) {
            mc.think(`If he isn't, I'll have to think if I'll let Ann go with him.`);

        } else {
            mc.think(`I guess we'll see in a few days.`);

        }
    } else {

    }
    if (Question.globalAnswers.v4AgreedToChrisProposal) {

        return jump(V5ChrisBar, "V5ChrisBar");
    }


    return jump(V5RoomAloneAfterAnnEvents, "V5RoomAloneAfterAnnEvents");
};




export const V5ChrisBar = async (): Promise<any> => {
    if (Game.seenScenarios.includes(`V5ChrisBar`)) {

        ImageClass.setImage(images.v1.RoomComputerAlone);
    } else {

        await Phone.showMessagesUI({ name: chris.name }, async () => {
            Phone.setMessage({ character: chris.character, text: `Yo, ${mc.name}! It's Chris I got your number from Vanessa.`, options: { wait: false } });
            Phone.setMessage({ character: mc.character, text: `Hey, what's up?` });
            Phone.setMessage({ character: chris.character, text: `Not much. I'm at the bar, why don't you come over?` });
            Phone.setMessage({ character: mc.character, text: `Is there a particular reason?` });
            Phone.setMessage({ character: chris.character, text: `I'll tell you once you get here.` });
            Phone.setMessage({ character: mc.character, text: `Ok, OMW.` });
            Phone.closeMessagesUI();
        });
    }
    mc.think(`Yesterday he wanted to fuck me over, I wonder what he could want.`);
    mc.think(`The best way to find out is to go there and see.`);
    return jump(V5ChrisRandomGirl, "V5ChrisRandomGirl");
};

export const V5RoomAloneAfterAnnEvents = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomComputerAlone, { transition: true });
    mc.think(`I hear noises coming from the living room.`);
    return jump(V5EmilyNight, "V5EmilyNight");
};


export const V5EmilyNight = async (): Promise<any> => {
    ImageClass.setImage(images.v5.EmilyLivingroom_0, { transition: true });
    mc.think(`Emily? Why is she laying in the dark?`);
    ImageClass.setImage(images.v5.EmilyLivingroom_1);
    mc.talk(`Emily?`);
    ImageClass.setImage(images.v5.EmilyLivingroom_2);
    emily.talk(`${mc.name}? I didn't hear you.`);
    mc.talk(`Why are you lying in the dark?`);
    if (Game.seenScenarios.includes(`V5EmilyBeach`)) {
        emily.talk(`I went to sleep after we got back from the beach and now I'm not tired.`);

    } else {

        emily.talk(`I went to sleep after I got back and now I'm not tired.`);
    }


    emily.talk(`Did I disturb you? I can go to my room.`);
    mc.talk(`No, not at all, I wasn't sleeping.`);
    emily.talk(`In that case, come, sit down and let's chat.`);
    ImageClass.setImage(images.v5.EmilyLivingroom_3);
    if (mc.properties.annStatus === "gf") {
        if (ann.properties.isCorrupted) {
            if (Game.seenScenarios.includes(`V5AnnMovieAgree_2_1_Inside_Touch`)) {
                emily.talk(`Sorry about earlier, I didn't know you had company.`);
                emily.talk(`She must have been really embarrassed. I can't imagine being her.`);
                mc.talk(`For a bit, but she got over it.`);
            } else {
                emily.talk(`I hope I didn't disturb you earlier. I didn't know you had company.`);

            }




            mc.talk(`That was Ann by the way.`);
            if (Game.seenScenarios.includes(`V5EmilyBeach`)) {

                return jump(V5EmilyNightWasAtBeach, "V5EmilyNightWasAtBeach");
            }

            return jump(V5EmilyNightWasntAtBeach, "V5EmilyNightWasntAtBeach");
        } else {

        }
    } else {

    }

    if (Game.seenScenarios.includes(`V5EmilyBeach`)) {

        emily.talk(`What were you doing after we got back from the beach?`);
    }


    if (mc.properties.joeStatus !== "enemy") {
        ImageClass.setImage(images.v5.EmilyLivingroom_3);
        emily.talk(`How was your day?`);
        emily.talk(`I'm not used to not seeing you sit at home and play video games all day.`);
        ImageClass.setImage(images.v5.EmilyLivingroom_4);
        mc.talk(`I went with Joe to the beach.`);
        ImageClass.setImage(images.v5.EmilyLivingroom_5);
        emily.talk(`The beach? You? No way!`);
        emily.talk(`When did you start to go to the beach?`);
        ImageClass.setImage(images.v5.EmilyLivingroom_4);
        mc.talk(`Lately.`);
        ImageClass.setImage(images.v5.EmilyLivingroom_5);
        emily.talk(`We should go together sometime!`);
        ImageClass.setImage(images.v5.EmilyLivingroom_4);
        mc.talk(`Sure, why not.\nIt could be fun.`);

        ImageClass.setImage(images.v5.EmilyLivingroom_5);
        emily.talk(`So what were you doing there?`);
        ImageClass.setImage(images.v5.EmilyLivingroom_4);
        mc.talk(`Just talking.`);
        ImageClass.setImage(images.v5.EmilyLivingroom_5);
        emily.talk(`About what? Girls?`);
        ImageClass.setImage(images.v5.EmilyLivingroom_4);
        mc.talk(`Among other things.`);

        ImageClass.setImage(images.v5.EmilyLivingroom_5);
        emily.talk(`Really? I hope you are not joking with me!`);
    } else {

    }

    if (mc.properties.annStatus === "gf") {

        if (Game.seenScenarios.includes(`V5EmilyBeach`)) {
            mc.talk(`Nothing really... I just spent my time on the computer.`);

            return jump(V5EmilyNight_2, "V5EmilyNight_2");
        }

        ImageClass.setImage(images.v5.EmilyLivingroom_4);
        mc.talk(`There is this girl...`);
        mc.talk(`Relativity new.`);
        ImageClass.setImage(images.v5.EmilyLivingroom_5);
        emily.talk(`What's her name???`);
        mc.talk(`Ann.`);

        return jump(V5EmilyNightWasntAtBeach, "V5EmilyNightWasntAtBeach");
    } else {

    }


    ImageClass.setImage(images.v5.EmilyLivingroom_4);
    mc.talk(`I'm not.`);
    ImageClass.setImage(images.v5.EmilyLivingroom_5);
    emily.talk(`Well... That's boring.`);

    ImageClass.setImage(images.v5.EmilyLivingroom_4);
    mc.talk(`What can I do? Introduce me to some of your female friends and I'll have interesting stories for you.`);
    ImageClass.setImage(images.v5.EmilyLivingroom_5);
    emily.talk(`You know I don't have female friends.`);

    ImageClass.setImage(images.v5.EmilyLivingroom_4);
    mc.talk(`Me neither.`);

    ImageClass.setImage(images.v5.EmilyLivingroom_4);
    mc.talk(`Since I don't have anything interesting to say.`);
    return jump(V5EmilyNight_2, "V5EmilyNight_2");

};

export const V5EmilyNightWasAtBeach = async (): Promise<any> => {
    ImageClass.setImage(images.v5.EmilyLivingroom_5);
    emily.talk(`Oh, that's the girl you were talking about at the beach!`);
    emily.talk(`She didn't look innocent at all.`);

    ImageClass.setImage(images.v5.EmilyLivingroom_4);
    mc.talk(`You must be talking about the way she dressed, which surprised me as well.`);

    ImageClass.setImage(images.v5.EmilyLivingroom_4);
    mc.talk(`Something got over her.`);
    ImageClass.setImage(images.v5.EmilyLivingroom_5);
    emily.talk(`You said you are planning to change her, so I guess that's a good thing.`);

    ImageClass.setImage(images.v5.EmilyLivingroom_4);
    mc.talk(`It is.`);

    ImageClass.setImage(images.v5.EmilyLivingroom_5);
    emily.talk(`I'm glad I saw her, but I wish it was under better circumstances. Haha.`);

    ImageClass.setImage(images.v5.EmilyLivingroom_4);
    mc.talk(`Don't worry. You will have plenty of time to talk.`);
    ImageClass.setImage(images.v5.EmilyLivingroom_5);
    emily.talk(`I hope!`);

    return jump(V5EmilyNight_2, "V5EmilyNight_2");
};

export const V5EmilyNightWasntAtBeach = async (): Promise<any> => {
    ImageClass.setImage(images.v5.EmilyLivingroom_5);
    emily.talk(`Ann? Never heard that name before.`);

    ImageClass.setImage(images.v5.EmilyLivingroom_4);
    mc.talk(`Yeah, she is new.`);

    ImageClass.setImage(images.v5.EmilyLivingroom_5);
    emily.talk(`How did you meet her?`);

    ImageClass.setImage(images.v5.EmilyLivingroom_4);
    mc.talk(`Vanessa introduced us.`);
    ImageClass.setImage(images.v5.EmilyLivingroom_5);
    emily.talk(`Another new name! Who is Vanessa?`);

    ImageClass.setImage(images.v5.EmilyLivingroom_4);
    mc.talk(`Joey's girlfriend...`);
    ImageClass.setImage(images.v5.EmilyLivingroom_5);
    emily.talk(`Joey also has a girlfriend? Look at you two!`);

    ImageClass.setImage(images.v5.EmilyLivingroom_5);
    emily.talk(`I can't believe that I've missed so much.`);
    ImageClass.setImage(images.v5.EmilyLivingroom_5);
    emily.talk(`Tell me a bit about Ann! What's she like?`);
    if (ann.properties.isCorrupted) {
        ImageClass.setImage(images.v5.EmilyLivingroom_4);
        mc.talk(`Well. I was about to say she is cute and shy, but she is starting to act differently.`);
        ImageClass.setImage(images.v5.EmilyLivingroom_5);
        emily.talk(`How come? What happened?`);

        ImageClass.setImage(images.v5.EmilyLivingroom_4);
        // mc.talk(`I believe it's me encouraging her to try different things.`);
        mc.talk(`She decided to try and be more out going...`);
        if (mc.properties.annBarCorruptionConv) {
            mc.talk(`She said that I might've triggered it.`);
            emily.talk(`Oh look at you! Haha.`);

        } else {
            mc.talk(`Which I think I may have inadvertently encouraged.`);
        }
    } else {

        ImageClass.setImage(images.v5.EmilyLivingroom_4);
        mc.talk(`She is really cute and innocent.`);
        ImageClass.setImage(images.v5.EmilyLivingroom_5);
        emily.talk(`Oh.`);
        ImageClass.setImage(images.v5.EmilyLivingroom_5);
        emily.talk(`She sounds like a good girl.`);

        ImageClass.setImage(images.v5.EmilyLivingroom_4);
        mc.talk(`She really is.`);
    }

    ImageClass.setImage(images.v5.EmilyLivingroom_5);
    emily.talk(`I know I'm not supposed to ask this but I am way too curious.`);
    ImageClass.setImage(images.v5.EmilyLivingroom_5);
    emily.talk(`Did you have sex with her yet?`);

    ImageClass.setImage(images.v5.EmilyLivingroom_4);
    mc.talk(`Working on it.`);
    if (Game.seenScenarios.includes(`V5AnnMovieAgree_2_1_Inside_Touch`)) {
        ImageClass.setImage(images.v5.EmilyLivingroom_5);
        emily.talk(`Really? After that little show today I was sure you had. Haha.`);

    }

    ImageClass.setImage(images.v5.EmilyLivingroom_5);
    emily.talk(`What's holding you back?`);

    ImageClass.setImage(images.v5.EmilyLivingroom_4);
    mc.talk(`She is, but don't worry.`);

    ImageClass.setImage(images.v5.EmilyLivingroom_5);
    emily.talk(`I can't believe I can finally talk to you about these kinds of things.`);
    ImageClass.setImage(images.v5.EmilyLivingroom_5);
    emily.talk(`I've waited for so long for you to bring a girl home.`);
    if (Game.seenScenarios.includes(`V5AnnMovieAgree_2_1_Inside_Touch`)) {

        ImageClass.setImage(images.v5.EmilyLivingroom_4);
        mc.talk(`I'm getting the feeling you knew we were there and showed up on purpose.`);
        ImageClass.setImage(images.v5.EmilyLivingroom_5);
        emily.talk(`No way! I honestly didn't know she was there with you.`);

    }
    return jump(V5EmilyNight_2, "V5EmilyNight_2");
};

export const V5EmilyNight_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.EmilyLivingroom_4);
    mc.talk(`What about you? What were you doing on your phone?`);
    ImageClass.setImage(images.v5.EmilyLivingroom_5);
    emily.talk(`It's nothing.`);

    ImageClass.setImage(images.v5.EmilyLivingroom_4);
    mc.talk(`You were really focused, you didn't even see me standing here.`);

    if (mc.properties.joeStatus === "enemy") {

        ImageClass.setImage(images.v5.EmilyLivingroom_5);
        emily.talk(`It's nothing important, it's my ex again...`);
    } else {
        ImageClass.setImage(images.v5.EmilyLivingroom_5);
        emily.talk(`It's nothing important, it's someone I met right after I moved out...`);

        emily.talk(`He hit on me while I was on my first shopping spree. He approached me and we started talking.`);
        emily.talk(`But I won't lie, I wouldn't have spent time talking to him if I wasn't feeling a bit lonely.`);

        ImageClass.setImage(images.v5.EmilyLivingroom_4);
        mc.talk(`That was perfect timing for him.`);
        ImageClass.setImage(images.v5.EmilyLivingroom_5);
        emily.talk(`Yea...`);
        mc.talk(`Why did you break up?`);
        ImageClass.setImage(images.v5.EmilyLivingroom_6);
        emily.talk(`I'd rather not talk about that... Let's say that things just didn't work out...`);
        mc.talk(`Ok, I respect that. But if you ever want to talk about it, I'm here.`);
        emily.talk(`Thanks ${mc.name}.`);
    }


    ImageClass.setImage(images.v5.EmilyLivingroom_4);
    mc.talk(`What does he want now?`);
    ImageClass.setImage(images.v5.EmilyLivingroom_5);
    emily.talk(`To annoy me it seems.`);
    ImageClass.setImage(images.v5.EmilyLivingroom_6);
    emily.talk(`He keeps texting me, asking me if I miss him and stuff.`);

    ImageClass.setImage(images.v5.EmilyLivingroom_4);
    mc.talk(`What did you say?`);
    ImageClass.setImage(images.v5.EmilyLivingroom_5);
    emily.talk(`Nothing, I keep ignoring him.`);
    ImageClass.setImage(images.v5.EmilyLivingroom_6);
    emily.talk(`He is in the past for me.\nI don't have time for his bullshit.`);

    ImageClass.setImage(images.v5.EmilyLivingroom_4);
    mc.talk(`You seem to know what you are doing, which is good.`);
    ImageClass.setImage(images.v5.EmilyLivingroom_5);
    emily.talk(`He didn't show any signs that he cares when I left, and suddenly he is "missing me".`);
    ImageClass.setImage(images.v5.EmilyLivingroom_5);
    emily.talk(`But who cares about him, right?`);

    ImageClass.setImage(images.v5.EmilyLivingroom_4);
    mc.talk(`Right.`);


    ImageClass.setImage(images.v5.EmilyLivingroom_4);
    mc.talk(`Well. I'm off to bed.`);
    ImageClass.setImage(images.v5.EmilyLivingroom_3);
    emily.talk(`Good night ${mc.name}.`);



    return jump(V5EndDay1Room, "V5EndDay1Room");
};


export const V5EndDay1Room = async (): Promise<any> => {
    ImageClass.setImage(images.v5.Room2_2);
    mc.think(`Night...`);

    return jump(V5RoomAloneVanessaCall, "V5RoomAloneVanessaCall");
};


export const V5RoomAloneVanessaCall = async (): Promise<any> => {
    ImageClass.setImage(images.v1.Room2, { duration: 1.5, wait: 1.5, hideText: true });

    await Phone.showMessagesUI({ name: vanessa.name, profileImage: extras.VanessaProfilePic2 }, async () => {

        Phone.setMessage({ character: vanessa.character, text: `${mc.name}`, options: { wait: false } });
        Phone.setMessage({ character: vanessa.character, text: `${mc.name}`, options: { wait: false } });
        Phone.setMessage({ character: vanessa.character, text: `${mc.name}`, options: { wait: false } });
        Phone.setMessage({ character: vanessa.character, text: `${mc.name}`, options: { wait: false } });
        Phone.setMessage({ character: vanessa.character, text: `${mc.name}`, options: { wait: false } });
        Phone.setMessage({ character: vanessa.character, text: `${mc.name}`, options: { wait: false } });
        Phone.setMessage({ character: vanessa.character, text: `${mc.name}`, options: { wait: false } });
        Phone.setMessage({ character: mc.character, text: `Jeez! Relax! What happened?` });
        Phone.setMessage({ character: vanessa.character, text: `Get dressed and come over to my house. NOW!` });
        Phone.setMessage({ character: mc.character, text: `WTF? Why? It's still early...` });
        Phone.setMessage({ character: vanessa.character, text: `Funny story but my father thought you are Joe and that's why he let you inside the house in the first place.` });
        Phone.setMessage({ character: vanessa.character, text: `He told my mother and now they want you to come over for breakfast.` });
        Phone.setMessage({ character: mc.character, text: `Are you serious? Right now?` });
        Phone.setMessage({ character: mc.character, text: `Who invites people over for breakfast? What happened to dinner?` });
        Phone.setMessage({ character: vanessa.character, text: `My stupid parents do. Come over already.` });
        Phone.setMessage({ character: mc.character, text: `Just tell them I'm not Joey so I could get back to sleep.` });
        Phone.setMessage({ character: vanessa.character, text: `Are you insane? I kept Joe hidden from them, they wouldn't like him.` });
        Phone.setMessage({ character: mc.character, text: `Why not?` });
        Phone.setMessage({ character: vanessa.character, text: `OMG!!! I don't have time for small talk right now.` });
        Phone.setMessage({ character: mc.character, text: `Fine....... Should I bring something?` });
        Phone.setMessage({ character: vanessa.character, text: `An extra head because my father will tear yours apart if you are going to be late.` });
        Phone.setMessage({ character: mc.character, text: `:O` });
        Phone.setMessage({ character: vanessa.character, text: `See you in a few, bye!` });

        Phone.closeMessagesUI();
    });
    mc.think(`A breakfast with Vanessa's parents while they think I'm her boyfriend.`);
    mc.think(`That sounds like something I'd rather avoid.`);
    mc.think(`But what can happen? Anyway, I'm hungry, I wouldn't mind eating a good meal right now.`);
    return jump(V5VanessaBreakfast, "V5VanessaBreakfast");
};

export const V5VanessaBreakfast = async (): Promise<any> => {
    doTransition(images.v5.VanessaFrontDoor_0);

    mc.think(`Here we are again.`);
    doDoorKnock();
    ImageClass.setImage(images.v5.VanessaFrontDoor_3);
    vanessaDad.talk(`You are late.`);
    mc.talk(`You didn't give me a specific time to be here.`);
    vanessaDad.talk(`Don't be a smart ass.`);
    ImageClass.setImage(images.v5.VanessaFrontDoor_2);
    vanessaDad.talk(`Let's get inside, Ramona is waiting in the kitchen.`);
    mc.think(`That must be Vanessa's mom.`);
    ImageClass.setImage(images.v5.VanessaDinner_1, { transition: true });
    vanessaMom.talk(`Joe!`);
    vanessaMom.think(`*Whisk Whisk*`);
    vanessaMom.talk(`Nice to meet you.`);
    vanessaMom.think(`*Whisk Whisk*`);
    mc.talk(`Nice to meet you too.`);
    mc.think(`Now I see where Vanessa got her boobs from.`);
    vanessaMom.talk(`What a handsome boy!`);
    vanessaMom.talk(`I can't say that I've heard much about you.`);
    vanessaMom.talk(`Vanessa did an excellent job of hiding you from us.`);
    vanessaMom.talk(`Please, sit at the table, the food will be ready any minute now.`);
    ImageClass.setImage(images.v5.VanessaDinner_0);
    vanessaDad.talk(`...`);
    mc.think(`He is just staring at me.`);
    vanessaMom.talk(`You are so quiet back there.`);
    vanessaMom.talk(`Don't be rude James.`);
    await vanessaDad.setQuestion(new Question({ text: `Joe, what do you do right now?`, options: { think: false }, key: `v5VanessaDadAnswer1` })
        .option({ title: `Sitting`, key: `sitting` })
        .option({ title: `Unemployed at the moment`, key: `unemployed` }));


    if (Question.globalAnswers.v5VanessaDadAnswer1 === "sitting") {
        mc.talk(`Sitting.`);
        vanessaDad.talk(`I warned you.`);
        vanessaMom.talk(`A sense of humor. I like it!`);
        vanessaDad.talk(`So you are unemployed.`);
        mc.talk(`Yeah...`);
    } else {
        mc.talk(`Unemployed at the moment.`);
    }
    vanessaDad.talk(`It's been a year since you finished school and you are still doing nothing with your life?`);
    mc.talk(`I guess...`);

    return jump(V5VanessaBreakfast2, "V5VanessaBreakfast2");
};

export const V5VanessaBreakfast2 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.VanessaDinner_0);
    vanessaDad.talk(`Let me just tell you this straight.`);
    vanessaDad.talk(`Vanessa is a good kid, she has big goals and aspirations, I don't want you to drag her down.`);
    vanessaDad.talk(`I didn't even want her to have a boyfriend, I don't think she is ready for that right now.`);
    mc.talk(`Are you sure you are talking about Vanessa?`);
    vanessaDad.talk(`What's that supposed to mean?\nI know my daughter.`);
    mc.think(`If I didn't meet him earlier, I would have thought I am in the wrong house.`);
    vanessaMom.talk(`Please forgive James, he is overprotective when it comes to Vanessa.`);
    vanessaMom.talk(`Sometimes I agree with him, we don't want our daughter to turn out to be like her friend.`);
    mc.talk(`Like her friend? Which one?`);
    vanessaMom.talk(`Her name is Ann. She is the daughter of our friends.`);

    vanessaDad.talk(`Do you know her?`);
    mc.talk(`Yes, I do.`);
    if (mc.properties.annStatus === "hate") {
        vanessaMom.talk(`I've seen how she started to dress.\nWay too cheap for my taste.`);

    } else {

    }

    vanessaMom.talk(`I'm afraid she is a bad influence on Vanessa.`);
    mc.talk(`Are you sure about that?`);
    vanessaDad.talk(`Damn right she is.`);
    vanessaDad.talk(`Her parents are blind to see what's going on under their noses.`);
    vanessaDad.talk(`They work hard and I appreciate it. But they did a poor job of educating their daughters.`);
    vanessaDad.talk(`Ramona and I also work hard, but we still invest time into our lovely daughter.`);
    mc.talk(`Yeah...`);


    return jump(V5VanessaBreakfast3, "V5VanessaBreakfast3");
};
export const V5VanessaBreakfast3 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.VanessaDinner_2, { duration: 0.6 });
    vanessa.talk(`Good morning Father!`);
    mc.think(`What the fuck is she wearing?`);
    vanessaDad.talk(`There's my beautiful daughter!`);
    vanessaDad.talk(`Join us.`);
    vanessa.talk(`Hehe, thanks Father.`);
    ImageClass.setImage(images.v5.VanessaDinner_3);
    mc.think(`I'm starting to understand what's going on.`);
    vanessaDad.talk(`Joe, Vanessa didn't tell us much about you.`);
    await vanessaDad.setQuestion(new Question({ text: `What do you like to do in your free time?`, options: { think: false }, key: `v5VanessaDadAnswer2` })
        .option({ title: `I like to study`, key: `study` })
        .option({ title: `I like to go out`, key: `goOut` })
        .option({ title: `Play the computer`, key: `playTheComputer` }));


    if (Question.globalAnswers.v5VanessaDadAnswer2 === 'study') {

        mc.talk(`I like to study.`);
        vanessaDad.talk(`That's good.\nStudy hard and be successful one day.`);
    } else if (Question.globalAnswers.v5VanessaDadAnswer2 === 'goOut') {

        mc.talk(`I like to go out.`);
        vanessaDad.talk(`Are you some kind of a party boy?`);
        ImageClass.setImage(images.v5.VanessaDinner_4);
        vanessa.talk(`Of course not! Hehe! He is just joking.`);
        vanessa.talk(`Right Joe???`);
        mc.talk(`Yes, of course.`);
    } else {

        mc.talk(`Playing the computer.`);
        vanessaDad.talk(`Oh, a nerd, that's not too bad.`);
    }

    return jump(V5VanessaBreakfast4, "V5VanessaBreakfast4");
};

export const V5VanessaBreakfast4 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.VanessaDinner_3);
    vanessaDad.talk(`What do your parents do for a living?`);
    mc.talk(`My father is a consultant for startup companies and my mom assists him.`);
    vanessaDad.talk(`Assists him? Like his secretary?`);
    mc.talk(`I believe she does more, but I'm not sure, I never asked for details.`);
    vanessaDad.talk(`Sounds like your father is a man with a plan.\nI hope you will follow his path.`);
    ImageClass.setImage(images.v5.VanessaDinner_5);
    vanessaMom.talk(`He looks like a smart boy, I'm sure he will do alright.`);
    ImageClass.setImage(images.v5.VanessaDinner_6);
    vanessaDad.talk(`He must. I don't want Vanessa to be dating a bum.`);
    vanessaMom.talk(`They are still young, now is their time to enjoy life without worries.`);
    vanessaDad.talk(`Those are the kind of people you find lying drunk in some alley.`);
    ImageClass.setImage(images.v5.VanessaDinner_7);
    vanessaMom.talk(`Don't let James make you nervous.\nI'm sure you realized he is doing it because he cares for Vanessa.`);
    ImageClass.setImage(images.v5.VanessaDinner_8);
    vanessaDad.talk(`How were your grades at school?`);
    mc.talk(`They were alright.`);
    vanessaDad.talk(`Just alright?`);
    mc.talk(`They were ok, no one complained about them.`);
    mc.think(`Jeez, what's with all the questions?`);
    return jump(V5VanessaBreakfast4_Question, "V5VanessaBreakfast4_Question");
};

export const V5VanessaBreakfast4_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v5.VanessaDinner_8);
    await vanessaDad.setQuestion(new Question({ text: `Tell me, what do you like about Vanessa?`, options: { think: false }, key: `v5VanessaDadAnswer3WhatDoYouLikeAboutVanessa` })
        .option({ title: `Her look`, key: `herLook` })
        .option({ title: `Her personality`, key: `herPersonality` }));


    if (Question.globalAnswers.v5VanessaDadAnswer3WhatDoYouLikeAboutVanessa === 'herLook') {

        return jump(V5VanessaBreakfast4_Look, "V5VanessaBreakfast4_Look");
    } else {
        return jump(V5VanessaBreakfast4_personality, "V5VanessaBreakfast4_personality");

    }
};


export const V5VanessaBreakfast4_Look = async (): Promise<any> => {
    ImageClass.setImage(images.v5.VanessaDinner_8);
    mc.talk(`Her look.`);
    vanessaDad.talk(`Are you serious?`);
    vanessaDad.talk(`I know she is the most beautiful girl in the world, but that's the only reason you are seeing her?`);
    mc.talk(`Not just... You asked what I liked about her...`);
    return jump(V5VanessaBreakfast5, "V5VanessaBreakfast5");
};


export const V5VanessaBreakfast4_personality = async (): Promise<any> => {
    ImageClass.setImage(images.v5.VanessaDinner_8);
    mc.talk(`Her personality.`);
    vanessaDad.talk(`Good.`);
    mc.think(`I guess that's the right answer.`);
    return jump(V5VanessaBreakfast5, "V5VanessaBreakfast5");
};

export const V5VanessaBreakfast5 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.VanessaDinner_7);
    vanessaMom.talk(`Everything is ready. Let's start.`);
    mc.think(`Saved by the bell.`);
    mc.think(`Or by the lady with the big ass boobs...`);
    ImageClass.setImage(images.v5.VanessaDinner_9);
    vanessaMom.talk(`Joe, I hope you are hungry.`);
    mc.talk(`I am, thank you.`);
    ImageClass.setImage(images.v5.VanessaDinner_10);
    vanessaMom.talk(`James and I work very hard, but we still try to make family breakfasts once a week.`);
    mc.think(`Why do they keep mentioning their work all of the time?`);
    vanessaMom.talk(`You are invited to join us anytime!`);
    mc.talk(`Thank you.`);
    vanessaMom.talk(`I know that most people have dinner, but we are barely at home in the evenings so we do what we can.`);
    vanessaMom.talk(`Let's eat!`);
    doTransition(images.v5.VanessaDinner_12);
    vanessaMom.talk(`How was it?`);
    mc.talk(`It was delicious, thank you.`);
    vanessaMom.talk(`I can see that! You finished your plate.`);
    return jump(V5VanessaBreakfast6, "V5VanessaBreakfast6");
};

export const V5VanessaBreakfast6 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.VanessaDinner_13_2);
    vanessa.talk(`Mother, can Joe and I be excused from the table?`);
    vanessaMom.talk(`And do what?`);
    vanessa.talk(`Go and study in my room!`);
    vanessaDad.talk(`Out of the question.`);
    ImageClass.setImage(images.v5.VanessaDinner_14);
    vanessaMom.talk(`Wait, James, let's see what she has to say.`);
    vanessaDad.talk(`It's bad enough that I allowed it yesterday.`);

    vanessa.talk(`We won't be alone, Ann should join us soon.`);
    mc.think(`I didn't know that Vanessa invited Ann...`);
    vanessaMom.talk(`Mmm...`);
    ImageClass.setImage(images.v5.VanessaDinner_13_2);
    vanessaMom.talk(`You know I don't like it when you spend too much time with her.`);
    vanessa.talk(`Joe will be with us to make sure she won't do anything funny.`);
    vanessaMom.talk(`Fine.`);
    ImageClass.setImage(images.v5.VanessaDinner_13);

    vanessa.talk(`REALLY?`);
    vanessaMom.talk(`We are going out, the house will be empty, I trust you.`);
    vanessaDad.talk(`You've gone soft.`);
    ImageClass.setImage(images.v5.VanessaDinner_14);
    vanessaMom.talk(`Relax James, she is a good girl. She deserves some slack.`);
    vanessa.talk(`Thanks Mother!`);
    ImageClass.setImage(images.v5.VanessaDinner_13_2);
    vanessaMom.talk(`Don't forget to behave.`);
    vanessa.talk(`I won't!`);


    return jump(V5VanessaBreakfastVanessaRoom, "V5VanessaBreakfastVanessaRoom");
};

export const V5VanessaBreakfastVanessaRoom = async (): Promise<any> => {
    doTransition(images.v5.VanessaAfterBreakfast_0);
    vanessa.talk(`Finally, that fucking shit show is over!`);
    mc.talk(`Are your parents really that naive?`);
    vanessa.talk(`You have no idea.`);
    vanessa.talk(`Unzip me. This fucking dress is killing me.`);
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_1);
    mc.talk(`It's the first time I've seen you wearing a bra.`);
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_2);
    vanessa.talk(`Don't get used to it.`);
    mc.talk(`I won't, trust me.`);
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_8);

    mc.talk(`I have so many questions.`);
    mc.talk(`Why didn't you say anything over the phone? I wasn't ready for that at all.`);
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_7);
    vanessa.talk(`I was afraid you wouldn't show up.`);
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_8);
    mc.talk(`I might not have.`);
    mc.talk(`It could have been worse. I could have said something.`);
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_3);
    vanessa.talk(`They wouldn't believe you, they are delusional, they honesty think I'm a girl scout.`);
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_8);
    if (Question.globalAnswers.v4SexTapeAgreeToFilm) {
        mc.talk(`How come? Just yesterday we filmed a sex tape here, how could they be so blind?`);

    } else {
        mc.talk(`How come? I know Joey's been here a few times, how could they be so blind?`);

    }
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_7);
    vanessa.talk(`If there is one good thing you can say about my parents is that they respect my privacy.`);
    vanessa.talk(`When I'm in my room, they don't bother me, which is their biggest mistake.`);
    vanessa.talk(`Plus, they love to go out, and even when they are here they never pay attention to what I'm doing.`);

    ImageClass.setImage(images.v5.VanessaAfterBreakfast_8);
    mc.talk(`Don't they see the way you dress?`);
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_3);
    vanessa.talk(`Don't be a moron. I usually put some ugly dresses on top before I leave.`);
    vanessa.talk(`I usually throw it in the bushes.`);
    if (Question.globalAnswers.v4VanessaDrunkDidBodyShot === false) {
        ImageClass.setImage(images.v5.VanessaAfterBreakfast_8);
        mc.talk(`What about yesterday? I carried you home.`);
        ImageClass.setImage(images.v5.VanessaAfterBreakfast_7);
        vanessa.talk(`I won't lie, that was dangerous. If they were awake, they would have killed you.`);
        ImageClass.setImage(images.v5.VanessaAfterBreakfast_8);
        mc.talk(`ME?`);
        ImageClass.setImage(images.v5.VanessaAfterBreakfast_7);
        vanessa.talk(`Of course, I'm their daughter.`);
        ImageClass.setImage(images.v5.VanessaAfterBreakfast_8);
        mc.talk(`Pff...`);
    } else {

    }
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_8);
    mc.talk(`And do you want to tell me you've never been caught?`);
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_3);
    vanessa.talk(`Almost, I usually blame it on Ann.`);

    if (mc.properties.annStatus === "hate" || ann.properties.isCorrupted) {
        return jump(V5VanessaBreakfastVanessaRoomAnnJoined, "V5VanessaBreakfastVanessaRoomAnnJoined");

    }

    return jump(V5VanessaBreakfastVanessaRoomBringingAnn, "V5VanessaBreakfastVanessaRoomBringingAnn");
};

export const V5VanessaBreakfastVanessaRoomBringingAnn = async (): Promise<any> => {

    if (Game.seenScenarios.includes(`V5VanessaBreakfastVanessaRoomBringingAnn`)) {
        ImageClass.setImage(images.v5.VanessaAfterBreakfast_8);

    } else {
        ImageClass.setImage(images.v5.VanessaAfterBreakfast_7);
        vanessa.talk(`Where is she anyway? She was supposed to be here already.`);
        mc.talk(`Why? What did you plan?`);
        vanessa.talk(`Don't ruin the surprise.`);
        ImageClass.setImage(images.v5.VanessaAfterBreakfast_8);
        mc.talk(`Sec, I'll try to text her.`);

        await Phone.showMessagesUI({ name: ann.name, profileImage: annImages.Ann2 }, async () => {
            Phone.setMessage({ character: mc.character, text: `Ann?`, options: { wait: false } });
            Phone.setMessage({ character: ann.character, text: `${mc.name}! What's up?` });
            Phone.setMessage({ character: mc.character, text: `I'm great.` });
            Phone.setMessage({ character: mc.character, text: `Where are you?` });
            Phone.setMessage({ character: ann.character, text: `At the library, why?` });
            Phone.setMessage({ character: mc.character, text: `Weren't you supposed to meet with Vanessa?` });
            Phone.setMessage({ character: ann.character, text: `Oh...` });
            Phone.setMessage({ character: ann.character, text: `I told her that I might come if I'll manage to finish some stuff I wanted to finish.` });
            Phone.setMessage({ character: ann.character, text: `I have barely done any studying lately...` });
            Phone.setMessage({ character: ann.character, text: `Tell her I'm sorry and we'll meet some other time.` });
            Phone.setMessage({ character: mc.character, text: `I'll tell her.` });
            Phone.setMessage({ character: ann.character, text: `Talk to you later! Kisses!` });
            Phone.closeMessagesUI();
        });
    }

    ImageClass.setImage(images.v5.VanessaAfterBreakfast_7);
    vanessa.talk(`So?`);
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_8);
    mc.talk(`She ain't gonna come.`);
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_7);
    vanessa.talk(`What the fuck? Why?`);
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_8);
    mc.talk(`She said she needs to study.`);
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_7);
    vanessa.talk(`I can't believe it! No way.`);
    vanessa.talk(`Can you bring her?`);
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_8);
    mc.talk(`She said she needs to study...`);
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_7);
    vanessa.talk(`Fuck that! Just tell her to come here.`);
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_8);
    mc.talk(`Why do you think I'll manage to convince her?`);
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_7);
    vanessa.talk(`Control your woman!`);
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_8);
    mc.talk(`Fine! I'll try.`);
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_3);
    vanessa.talk(`Amazing! Cya soon with Ann.`);

    return jump(V5AnnLibrary, "V5AnnLibrary");
};


export const V5VanessaBreakfastVanessaRoomAnnJoined = async (): Promise<any> => {
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_3);
    empty.think(`*Door opens*`);
    ImageClass.setImage(images.v5.AnnVanessaRoom_24);
    if (mc.properties.annStatus === "hate") {

        mc.think(`Ann? I haven't seen her since she left with Chris the other day...`);
    }

    ann.talk(`Hello?`);

    ann.talk(`${mc.name}? What are you doing here?`);
    vanessa.talk(`Don't worry about him.`);
    if (ann.properties.isCorrupted) {
        ImageClass.setImage(images.v5.VanessaAfterBreakfast_4_Outfit);
        vanessa.talk(`Cute outfit, by the way!`);
        // ann.talk(`It's just something I had lying around...`);
        vanessa.talk(`I like it! You should wear more clothes like these and less of your grandma's clothes.`);
        ann.talk(`Working on it.`);
        ann.talk(`I gotta ask...`);
    } else {

        ImageClass.setImage(images.v5.VanessaAfterBreakfast_4);
    }
    ann.talk(`Why are you standing here in your bra while ${mc.name} is here...?`);
    vanessa.talk(`Because the dress was killing me.`);
    ann.talk(`So why did you put it on in the first place?`);

    vanessa.talk(`Because I was waiting for you and suddenly my parents said they wanted to meet Joe.`);
    vanessa.talk(`And obviously, I don't want them to meet Joe, so I called ${mc.name} instead.`);
    ann.talk(`Why? What's wrong with Joe?`);

    vanessa.talk(`Long story, no time.`);
    ann.talk(`Fine, so a different question.`);
    ann.talk(`I just saw your parents heading out and they gave me a real nasty look.\nWhat's happening?`);
    vanessa.talk(`Did they leave already? Great!`);
    if (ann.properties.isCorrupted) {

        ImageClass.setImage(images.v5.VanessaAfterBreakfast_5_Outfit);
    } else {

        ImageClass.setImage(images.v5.VanessaAfterBreakfast_5);
    }

    vanessa.talk(`${mc.name}, keep her company till I get back!`);
    mc.talk(`Sure.`);
    if (mc.properties.annStatus === "hate") {
        return jump(V5VanessaBreakfastVanessaRoomAnnJoinedStatus15, "V5VanessaBreakfastVanessaRoomAnnJoinedStatus15");

    }

    return jump(V5VanessaBreakfastVanessaRoomAnnJoined234, "V5VanessaBreakfastVanessaRoomAnnJoined234");

};
export const V5VanessaBreakfastVanessaRoomAnnJoinedStatus15 = async (): Promise<any> => {

    ImageClass.setImage(images.v5.VanessaAfterBreakfast_5_Outfit);
    if (mc.properties.annLateHate) {
        ann.talk(`I don't think it's a good idea.`);
        vanessa.talk(`Of course it is.`);
        vanessa.talk(`Just wait here for a minute and I'll be right back.`);

        ImageClass.setImage(images.v5.VanessaAfterBreakfast_6_Outfit);
        ann.talk(`Hey...`);
        mc.think(`The last time I saw her was a couple of days ago at the bar.`);
        mc.talk(`We didn't have a chance to talk at the bar.`);
        ann.talk(`No we didn't...`);
        mc.talk(`I didn't mean to hurt your feelings.`);
        ann.talk(`It's fine, you were just being honest.`);
        ann.talk(`I felt different vibes from you, so I was under the impression you felt something towards me.`);
        ann.talk(`Forget about that, I am in a good mood. I don't want to ruin it right now.`);
        mc.talk(`Ok.`);
    } else {
        ann.talk(`While you do what?`);
        vanessa.talk(`Don't ruin my surprise.`);
        ImageClass.setImage(images.v5.VanessaAfterBreakfast_6_Outfit, { transition: true });

        ann.talk(`So...`);
        ann.talk(`What's up?`);
        mc.talk(`I'm fine.`);
        mc.talk(`I haven't talked to you since the bar.`);
        ann.talk(`Yeah... I've been busy.`);
    }
    ann.talk(`Anyway, let's sit down, my legs are killing me.`);
    ImageClass.setImage(images.v5.AnnVanessaRoom_0);
    mc.talk(`Why do your legs hurt?`);
    ann.talk(`I was walking a lot yesterday. I went to see a movie premiere with Chris.`);
    mc.talk(`Doesn't he own a car?`);
    ann.talk(`He does, but I wanted to go on foot.`);
    mc.talk(`Alright. I'm glad to see you are ok.`);

    ann.talk(`Why wouldn't I be?`);
    mc.talk(`I don't know, because you left with Chris whom you don't know that well, and I haven't heard from you since.`);
    ann.talk(`Don't worry, he is amazing. I like him.`);
    if (mc.properties.v4SawAnnBJChrisInCar) {

        mc.think(`Of course she'd say that after she sucked his dick in his car.`);
    }
    return jump(V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson1Or5, "V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson1Or5");

};

export const V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson1Or5 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnVanessaRoom_0);
    empty.think(`*Door opens*`);
    ImageClass.setImage(images.v5.AnnVanessaRoom_outfit_2);
    vanessa.talk(`I'm ready.`);
    mc.talk(`What the fuck?`);
    ImageClass.setImage(images.v5.AnnVanessaRoom_outfit_3_2);
    vanessa.talk(`And you? Are you ready?`);
    ann.talk(`Of course.`);
    mc.talk(`Ready for what?`);
    // ImageClass.setImage(images.v5.AnnVanessaRoom_outfit_5_2);
    vanessa.talk(`I'm teaching Ann some things about life.`);
    mc.talk(`Things like what?`);
    ImageClass.setImage(images.v5.AnnVanessaRoom_6);
    vanessa.talk(`I'll show you.`);
    ImageClass.setImage(images.v5.AnnVanessaRoom_outfit_4_2);
    vanessa.talk(`This will help me explain.`);

    mc.think(`Ann asked Vanessa for sex lessons?`);
    mc.think(`How much can a person change in a couple of days?`);

    ann.talk(`Well... I don't want to sound rude but we need some privacy.`);

    vanessa.talk(`Let him stay, maybe he can give you some pointers.`);

    ann.talk(`Fine, but only for a minute.`);
    ImageClass.setImage(images.v5.AnnVanessaRoom_7);

    vanessa.talk(`Say ahhhhh.`);
    return jump(V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson3, "V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson3");
};

export const V5VanessaBreakfastVanessaRoomAnnJoined234 = async (): Promise<any> => {
    if (ann.properties.isCorrupted) {

        ImageClass.setImage(images.v5.VanessaAfterBreakfast_6_Outfit);
    } else {
        ImageClass.setImage(images.v5.VanessaAfterBreakfast_6);

    }


    ann.talk(`Can you fill me in on what's happening?`);

    mc.talk(`I was sleeping when Vanessa woke me up and asked me to come over and pretend to be Joe...`);
    ann.talk(`Why?`);
    mc.talk(`I don't know, she thinks they wouldn't like him.`);
    ann.talk(`I can understand... They are really protective...and...`);
    mc.talk(`Stupid?`);
    ann.talk(`I wanted to say blind but that works, hehe.`);
    mc.talk(`And what brings you here?`);
    ann.talk(`Let's sit.`);
    mc.talk(`Alright.`);
    ImageClass.setImage(images.v5.AnnVanessaRoom_0, { duration: 0.6 });
    ann.talk(`Vanessa asked me to come over as well.\nShe said she wants to show me something...`);
    mc.talk(`Show you what?`);
    ann.talk(`She didn't say, but I have an idea...`);
    ann.talk(`I think it's related to what we talked about yesterday morning.`);
    ann.talk(`Did you have a chance to talk to her about that?`);
    mc.talk(`I did.`);
    ann.talk(`So that must be it.`);
    return jump(V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson, "V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson");

};

export const V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson = async (): Promise<any> => {

    ImageClass.setImage(images.v5.AnnVanessaRoom_0);

    if (mc.properties.annStatus === "hate") {
        return jump(V5VanessaBreakfastVanessaRoomAnnJoinedStatus15, "V5VanessaBreakfastVanessaRoomAnnJoinedStatus15");

    }
    empty.think(`*Door opens*`);

    ImageClass.setImage(images.v5.AnnVanessaRoom_1);
    ann.talk(`Oh my God.`);

    ImageClass.setImage(images.v5.AnnVanessaRoom_outfit_2);
    vanessa.talk(`Are you ready for your first lesson?`);
    if (Game.seenScenarios.includes(`V5AtVanessasHouse`)) {

        mc.think(`Or maybe sooner...`);
    }


    ImageClass.setImage(images.v5.AnnVanessaRoom_3);
    ann.talk(`Oh my, what are you wearing?`);
    vanessa.talk(`It's a little something I bought for emergencies.`);
    vanessa.talk(`Hold on, the most important thing is missing.`);

    ImageClass.setImage(images.v5.AnnVanessaRoom_6, { duration: 0.6 });
    vanessa.talk(`Where is it?`);
    vanessa.talk(`Found it!`);

    ImageClass.setImage(images.v5.AnnVanessaRoom_5);
    vanessa.talk(`Now we are ready!`);

    ImageClass.setImage(images.v5.AnnVanessaRoom_4);
    ann.talk(`What are you planning to do with that?`);
    vanessa.talk(`It's something for lesson number one.`);
    vanessa.talk(`Say AHHHHHH...`);
    return jump(V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson2, "V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson2");

};

export const V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson2 = async (): Promise<any> => {

    ImageClass.setImage(images.v5.AnnVanessaRoom_18);

    ann.talk(`What? No way I'm touching it! Especially not when ${mc.name} is here...`);
    vanessa.talk(`Don't be a baby.`);
    ann.talk(`It's dirty! It was under your bed.`);
    vanessa.talk(`${mc.name}'s dick is dirtier and you sucked that.`);
    ann.talk(`...`);
    await vanessa.setQuestion(new Question({ text: `Let's get started.`, options: { think: false }, key: `v5SexSessionStoppedVanessa` })
        .option({ title: `Just watch`, key: false })
        .option({ title: `Stop Vanessa`, key: true }));


    if (Question.globalAnswers.v5SexSessionStoppedVanessa) {
        mc.talk(`Stop.`);
        ImageClass.setImage(images.v5.AnnVanessaRoom_19);
        vanessa.talk(`What?`);
        mc.talk(`I don't think it's a good idea.`);
        vanessa.talk(`Are you fucking kidding me right now?`);
        return jump(V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson4, "V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson4");
    }

    vanessa.talk(`Let's get started.`);
    vanessa.talk(`Lesson number one: Learn how to give blowjobs.`);
    ann.talk(`Are we seriously going to do this in front of ${mc.name}?`);

    ImageClass.setImage(images.v5.AnnVanessaRoom_7);
    vanessa.talk(`Sure.`);

    vanessa.talk(`Come on, tilt your head.`);
    vanessa.talk(`Good.`);

    ImageClass.setImage(images.v5.AnnVanessaRoom_8);

    vanessa.talk(`Relax your throat and let it slide in.`);
    mc.think(`Holy shit...is this really happening now?`);
    ImageClass.setImage(images.v5.AnnVanessaRoom_9);

    vanessa.talk(`Don't resist. It will make you cough.`);
    vanessa.talk(`Think of it like a part of you.`);

    ImageClass.setImage(images.v5.AnnVanessaRoom_10);

    ann.talk(`*Cough*`);
    vanessa.talk(`Don't resist!`);

    ImageClass.setImage(images.v5.AnnVanessaRoom_11);


    vanessa.talk(`Great! Let it slide inside.`);

    if (ann.properties.isCorrupted) {
        ImageClass.setImage(images.v5.AnnDildoAnim2.poster, { duration: 1 });
        vanessa.talk(`Now relax and let me flex your throat.`);

        return jump(V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson3, "V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson3");
    }
    return jump(V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson3AnnDoesntAgree, "V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson3AnnDoesntAgree");

};

export const V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson3AnnDoesntAgree = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnVanessaRoom_18);

    ann.talk(`That's enough.`);
    vanessa.talk(`What? We were just getting started.`);
    ann.talk(`Enough is enough.`);
    vanessa.talk(`You are so boring.`);
    ImageClass.setImage(images.v5.AnnVanessaRoom_12);
    ann.talk(`At least I tried.`);


    return jump(V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson4, "V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson4");
};


export const V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson3 = async (): Promise<any> => {
    ImageClass.setAnimation(images.v5.AnnDildoAnim2);

    ann.talk(`MMMM!`);

    vanessa.talk(`You are doing a great job.`);
    vanessa.talk(`Just a few more seconds.`);

    ImageClass.setImage(images.v5.AnnVanessaRoom_18);

    ann.talk(`That's enough.`);

    if (mc.properties.annStatus !== "hate") {

        vanessa.talk(`You did great!`);
    } else {
        ImageClass.setImage(images.v5.AnnVanessaRoom_13);
        vanessa.talk(`Didn't she do a great job?`);
        mc.talk(`She did great.`);
    }

    return jump(V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson4, "V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson4");

};

export const V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson4 = async (): Promise<any> => {

    ImageClass.setImage(images.v5.AnnVanessaRoom_12);

    if (mc.properties.annStatus === "hate") {
        ann.talk(`What about you? You should put on a show for ${mc.name} too.`);
        vanessa.talk(`Sure, why not? I like showing off my skills.`);

    } else {
        ann.talk(`What about you?`);
        vanessa.talk(`Do you really want to go there?`);

        // ann.talk(`I do.`);
        ann.talk(`Of course! As a good mentor you should show off your skills.`);

    }

    ImageClass.setImage(images.v5.AnnVanessaRoom_15);

    vanessa.talk(`Just a second.`);

    if (mc.properties.annStatus === "hate") {
        ann.talk(`Are you bringing out the big one?`);
        vanessa.talk(`Of course!`);

    } else {

        ann.talk(`What are you doing down there again?`);
    }


    ImageClass.setImage(images.v5.AnnVanessaRoom_16);

    if (mc.properties.annStatus !== "hate") {

        vanessa.talk(`Looking for this!`);
        ann.talk(`Oh my God! How many of these have you got down there?`);
        vanessa.talk(`Not enough.`);
    } else {

    }


    vanessa.talk(`Watch and learn.`);


    return jump(V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson5, "V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson5");

};

export const V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson5 = async (): Promise<any> => {

    ImageClass.setAnimation(images.v5.VanessaDildoAnim);
    if (mc.properties.annStatus === "hate") {

        ann.talk(`I've seen you do that a few times now.`);
        ann.talk(`And I still can't understand how it is possible to fit that size.`);
    } else {
        ann.talk(`Oh my.`);
        ann.talk(`How is it possible to fit that size???`);

    }


    ImageClass.setImage(images.v5.AnnVanessaRoom_16);

    vanessa.talk(`Easy.`);

    ImageClass.setImage(images.v5.AnnVanessaRoom_21);
    vanessa.talk(`One day you could do that too.`);
    vanessa.talk(`Just keep practicing.`);

    ImageClass.setImage(images.v5.AnnVanessaRoom_20);
    vanessa.talk(`Haha! It's bigger than your head.`);

    ImageClass.setImage(images.v5.AnnVanessaRoom_16);


    vanessa.talk(`Do you want to try?`);

    if (mc.properties.annStatus === "hate") {

        ImageClass.setImage(images.v5.AnnVanessaRoom_22_2);
        ann.talk(`Sure, but after ${mc.name} leaves.`);
        mc.talk(`I get the hint.`);
        ImageClass.setImage(images.v5.AnnVanessaRoom_23_2);
        vanessa.talk(`Thanks for putting up with my parents.`);
        mc.talk(`No problem. Cya later.`);

        return jump(V5HomeAfterVanessaAnn, "V5HomeAfterVanessaAnn");
    } else {
        if (Question.globalAnswers.v5SexSessionStoppedVanessa) {
            ann.talk(`Maybe some other time...`);

        } else {

            ann.talk(`No, I think I've learned enough for today.`);
        }
        vanessa.talk(`Just lick it.`);
    }


    return jump(V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson6_Question, "V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson6_Question");
};

export const V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson6_Question = async (): Promise<any> => {

    ImageClass.setImage(images.v5.AnnVanessaRoom_16);
    if (Question.globalAnswers.v5SexSessionStoppedVanessa) {
        ann.talk(`No, I'm done.`);

    } else {
        await ann.setQuestion(new Question({ text: `No, I'm done.`, options: { think: false }, key: `v5SexLessonAgreeToFinish` })
            .option({ title: `Vanessa is right`, key: false })
            .option({ title: `I agree, that's enough`, key: true }));
    }



    if (Question.globalAnswers.v5SexLessonAgreeToFinish === false) {
        await ann.set((properties) => {
            properties.corruption += 2;
        });
        return jump(V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson6_VanRight, "V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson6_VanRight");
    } else {
        await ann.set((properties) => {
            properties.corruption--;
        });
        return jump(V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson6_Enough, "V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson6_Enough");

    }
};


export const V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson6_VanRight = async (): Promise<any> => {

    ImageClass.setImage(images.v5.AnnVanessaRoom_16);

    mc.talk(`Vanessa is right.`);

    ImageClass.setImage(images.v5.AnnVanessaRoom_23);
    vanessa.talk(`I know!`);

    ImageClass.setImage(images.v5.AnnVanessaRoom_23_2);
    mc.talk(`You should at least give it a try.`);
    ann.talk(`No...`);
    if (!ann.properties.isCorrupted) {
        ann.talk(`If I knew what she is planning I would have stayed at the library.`);

    }
    mc.talk(`So what now?`);


    return jump(V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson6, "V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson6");
};


export const V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson6_Enough = async (): Promise<any> => {

    ImageClass.setImage(images.v5.AnnVanessaRoom_16);

    mc.talk(`I agree, that's enough.`);

    ImageClass.setImage(images.v5.AnnVanessaRoom_23_2);

    vanessa.talk(`What's wrong with you?`);
    mc.talk(`Nothing.`);
    vanessa.talk(`Whatever.`);


    return jump(V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson6, "V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson6");
};

export const V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson6 = async (): Promise<any> => {

    ImageClass.setImage(images.v5.AnnVanessaRoom_23_2);

    vanessa.talk(`${mc.name}, go home, relax, Ann will call you in a few hours.`);

    ImageClass.setImage(images.v5.AnnVanessaRoom_22_2);
    ann.talk(`What do you plan to do?`);

    vanessa.talk(`Trust me.`);
    ann.talk(`Fine.`);

    ImageClass.setImage(images.v5.AnnVanessaRoom_23_2);
    mc.talk(`Cya later.`);
    ann.talk(`Bye ${mc.name}.`);



    return jump(V5HomeAfterVanessaAnn, "V5HomeAfterVanessaAnn");
};

export const V5HomeAfterVanessaAnn = async (): Promise<any> => {

    doWaitImageByTime(images.v1.RoomComputerAlone, null, 1.5);

    if (!Game.seenScenarios.includes(`V5HomeAfterVanessaAnn`)) {
        await alex.set((properties) => {
            properties.instaFollowing = 70;
            properties.instaFollowers = 186888;
        });
        if (mc.properties.annStatus === "hate") {
            mc.think(`So Ann is becoming a slut...`);
            mc.think(`And it only took her a couple of days...`);
        } else {
            mc.think(`I'll find out what Vanessa is planning in a few hours.`);

        }
    }
    let continueName = `End day`;
    if (mc.properties.annStatus === "gf") {
        continueName = `Meet with Ann`;
    }
    await UI.add({
        key: "v5AfterVanessaOrAnnButtons",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.continue, tooltip: continueName, key: "continue" }
            ]
    });
    if (UI._globalUI.v5AfterVanessaOrAnnButtons === "insta") {
        await Insta.open(getInstaData());
    }
    if (UI._globalUI.v5AfterVanessaOrAnnButtons === "continue") {
        if (mc.properties.annStatus === "gf") {
            return jump(V5AnnSexEvening, "V5AnnSexEvening");
        }
        return jump(V5EndDay2, "V5EndDay2");

    }
    return jump(V5HomeAfterVanessaAnn, "V5HomeAfterVanessaAnn");

};

export const V5AnnSexEvening = async (): Promise<any> => {

    ImageClass.setImage(images.v1.RoomComputerAlone);
    empty.think(`*Buzz Buzz...*`);
    await Phone.showMessagesUI({ name: ann.name, profileImage: ann.properties.isCorrupted ? annImages.Ann5 : annImages.Ann2 }, async () => {
        Phone.setMessage({ character: ann.character, text: `I'm done with Vanessa.`, options: { wait: false } });
        Phone.setMessage({ character: mc.character, text: `How was it?` });
        Phone.setMessage({ character: ann.character, text: `It was alright.` });
        Phone.setMessage({ character: ann.character, text: `What are you doing right now?` });
        Phone.setMessage({ character: mc.character, text: `Nothing, just at home.` });
        Phone.setMessage({ character: ann.character, text: `Can you come over?` });
        Phone.setMessage({ character: mc.character, text: `Sure.` });
        Phone.setMessage({ character: ann.character, text: `Great!` });
        Phone.setMessage({ character: mc.character, text: `See you in a few minutes.` });
        Phone.closeMessagesUI();
    });


    return jump(V5AnnSexEvening2_Question, "V5AnnSexEvening2_Question");
};

export const V5AnnSexEvening2_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomComputerAlone);
    await mc.setQuestion(new Question({ text: `Should I tell Vanessa that I'm going to meet Ann?`, options: { think: true }, key: `v5ToldVanessaYouMeetAnn` })
        .option({ title: `Tell Vanessa`, key: true })
        .option({ title: `Don't tell her`, key: false }));


    if (Question.globalAnswers.v5ToldVanessaYouMeetAnn) {

        return jump(V5AnnSexEvening2_TellVanessa, "V5AnnSexEvening2_TellVanessa");
    } else {
        return jump(V5AnnSexEvening2, "V5AnnSexEvening2");

    }
};


export const V5AnnSexEvening2_TellVanessa = async (): Promise<any> => {
    ImageClass.setImage(images.v1.RoomComputerAlone);
    await Phone.showMessagesUI({ name: vanessa.name, profileImage: extras.VanessaProfilePic2 }, async () => {
        Phone.setMessage({ character: mc.character, text: `Hey! Just wanted to let you know that Ann sent me a text and asked me to meet up with her.`, options: { wait: false } });
        Phone.setMessage({ character: vanessa.character, text: `Amazing! When??` });
        Phone.setMessage({ character: mc.character, text: `Right now.` });
        Phone.setMessage({ character: vanessa.character, text: `Show that girl what she had been missing for so long!!` });
        Phone.setMessage({ character: mc.character, text: `Don't worry.` });
        Phone.setMessage({ character: vanessa.character, text: `I am!` });
        if (ann.properties.isCorrupted) {
            Phone.setMessage({ character: vanessa.character, text: `But I trust you...` });
            Phone.setMessage({ character: vanessa.character, text: `Because I have no choice...` });
            Phone.setMessage({ character: vanessa.character, text: `Or do I?` });
            Phone.setMessage({ character: mc.character, text: `What's that suppose to mean?` });
            Phone.setMessage({ character: vanessa.character, text: `Nothing! Have fun!` });
            Phone.setMessage({ character: vanessa.character, text: `😈` });
        } else {
            Phone.setMessage({ character: vanessa.character, text: `Because that girl is so stuck up.` });
            Phone.setMessage({ character: vanessa.character, text: `I tried to convince her to do stuff, but she just kept refusing.` });
            Phone.setMessage({ character: vanessa.character, text: `So yeah. Good luck with that.` });
            Phone.setMessage({ character: mc.character, text: `Thanks... I guess.` });
        }
        Phone.closeMessagesUI();
    });
    if (ann.properties.isCorrupted) {

        mc.think(`I hope I did the right choice by telling her...`);
    } else {
        mc.think(`It doesn't sound like Vanessa is pleased with their "First sex lesson..."`);
        mc.think(`I hope that doesn't mean that Ann is going stop trying. She had told me she wanted it.`);
        mc.think(`I guess I'm about to find out.`);
    }


    return jump(V5AnnSexEvening2, "V5AnnSexEvening2");
};

export const V5EndDay2 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.Room2_2, { transition: true });
    if (!Game.seenScenarios.includes(`V5EndDay2`)) {
        await alex.set((properties) => {
            properties.instaFollowing = 112;
            properties.instaFollowers = 226888;
        });
        if (ann.properties.isCorrupted || mc.properties.annStatus === "hate") {
            await ann.set((properties) => {
                properties.instaFollowing = 252;
                properties.instaFollowers = 85;
            });
        } else {

        }
    }
    if (Game.seenScenarios.includes(`V5AnnSexEveningVanessaJoined4`) && !Game.seenScenarios.includes(`V5EndDay2`)) {

        mc.talk(`That was better than I expected.`);
    }

    await UI.add({
        key: "v5EndDayButtons",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.sleepBtn, tooltip: "End day", key: "continue" }
            ]
    });
    if (UI._globalUI.v5EndDayButtons === "insta") {
        await Insta.open(getInstaData());
    }
    if (UI._globalUI.v5EndDayButtons === "continue") {

        const alexLikes = Insta.instaProfiles?.[alex.name]?.images.reduce((counter, imageCur, index) => (counter + (imageCur.mcLiked ? 1 : 0)), 0);
        if (!Game.seenScenarios.includes(`V5AlexEasterEgg2`) && alexLikes > 20) {

            return jump(V5AlexEasterEgg2, "V5AlexEasterEgg2");
        } else {
            mc.think(`Time to sleep.`);
        }

        return jump(V6Start, "V6Start");

    }
    return jump(V5EndDay2, "V5EndDay2");


};

export const V5AlexEasterEgg2 = async (): Promise<any> => {
   
    await V6AlexEasterEgg2();
    return jump(V5EndDay2, "V5EndDay2");

};



